import { createAction, props } from '@ngrx/store';

import { Participant } from '../../models/participant.model';
import { Signing } from '../../models/signing.model';

const SessionActions = {
  loadSession: '[Session] Load Session',
  loadSessionSuccess: '[Session] Load Session Success',
  loadSessionFailure: '[Session] Load Session Failure',
};

export const loadSession = createAction(
  SessionActions.loadSession,
  props<{ participantId: string }>(),
);

export const loadSessionSuccess = createAction(
  SessionActions.loadSessionSuccess,
  props<{ participant: Participant; signing: Signing }>(),
);

export const loadSessionFailure = createAction(
  SessionActions.loadSessionFailure,
  props<{ error: string }>(),
);
